import { BonusEligibility, BonusType } from "types/api"

const tenant = process.env.REACT_APP_TENANT || "Blockbets"

export const enumTenant = {
  Slotwhales: tenant,
  Kingcasi: tenant,
  Blockbets: tenant
}
export const tenantOptions = [
  // { value: enumTenant.Slotwhales, name: enumTenant.Slotwhales },
  // { value: enumTenant.Kingcasi, name: enumTenant.Kingcasi },
  { value: enumTenant.Blockbets, name: enumTenant.Blockbets }
]

export const bonusTypeOptions = Object.values(BonusType).map((value) => ({
  name: value,
  value,
  disable: value === BonusType.CUSTOM ? true : false // TODO: Remove CUSTOM bonus type
}))

export const bonusEligibilityOptions = [
  { name: "All products", value: BonusEligibility.ALL },
  { name: "Casino only", value: BonusEligibility.CASINO },
  { name: "Sportsbook only", value: BonusEligibility.SPORTS },
  { name: "Originals only", value: BonusEligibility.ORIGINALS }
]

export enum BonusGameCategory {
  card = "card",
  casual = "casual",
  craps = "craps",
  crash = "crash",
  fishing = "fishing",
  lottery = "lottery",
  poker = "poker",
  roulette = "roulette",
  slots = "slots",
  video_poker = "video_poker",
  virtual_sports = "virtual_sports",

  live_casino = "live_casino",
  sportsBook = "sportsBook"
}
